export default class SingleExcersionModal {
    triggers;
    modal;
    bodyClasses;
    postId = 0;
    isOpen = false;
    pathname = window.location.pathname.split('/');
    base = 'excursion';
    baseUrl = window.location.protocol + "//" + window.location.host + "/" + this.base;

    virtualModal = {
        title: null,
        meta: {
            duration: null,
            date: null,
            location: null
        },
        img: null,
        content: null,
        sharing: {
            facebook: null,
            twitter: null,
            email: null
        },
        prev: null,
        next: null,
        book: null,
    };

    constructor(modalSelector, bodyClasses = false) {
        this.modal = document.getElementById(modalSelector);
        this.createVirtualModal();
        this.triggers = document.querySelectorAll('[data-target="' + modalSelector + '"]');
        this.bodyClasses = bodyClasses;

        this.triggers.forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                this.postId = e.target.dataset.id;
                this.loadModal()
            })
        });
        if (this.pathname[1] === this.base) {
            this.loadModal(this.pathname[2]) 
            // this.loadModal(window.location.hash.split('#')[1])
        }
        document.body.addEventListener('click', (event) => {
            if (!event.target.closest('.excersion-modal-dialog') && !event.target.classList.contains('excersion-modal-dialog')) {
                this.closeModal();
            }
        });
    }

    createVirtualModal() {
        this.virtualModal.title = this.modal.querySelector('.excersion-title');
        this.virtualModal.meta.duration = this.modal.querySelector('.excersion-meta .duration');
        this.virtualModal.meta.date = this.modal.querySelector('.excersion-meta .date');
        this.virtualModal.meta.location = this.modal.querySelector('.excersion-meta .location');
        this.virtualModal.content = this.modal.querySelector('.excersion-content');
        this.virtualModal.img = this.modal.querySelector('.excersion-modal-img');
        this.virtualModal.sharing.facebook = this.modal.querySelector('.share-facebook');
        this.virtualModal.sharing.twitter = this.modal.querySelector('.share-twitter');
        this.virtualModal.sharing.email = this.modal.querySelector('.share-email');
        this.virtualModal.book = this.modal.querySelector('.excersion-book .btn');
        this.virtualModal.prev = this.modal.querySelectorAll('.excersion-prev .btn');
        this.virtualModal.prev.forEach(prev => prev.addEventListener('click', (e) => {
            e.preventDefault();
            this.postId = e.target.dataset.id || e.target.closest('.btn').dataset.id;
            this.loadModal()
        }));
        this.virtualModal.next = this.modal.querySelectorAll('.excersion-next .btn');
        this.virtualModal.next.forEach(next => next.addEventListener('click', (e) => {
            e.preventDefault();
            this.postId = e.target.dataset.id || e.target.closest('.btn').dataset.id;
            this.loadModal()
        }));
    }

    setPostData(post) {
        this.virtualModal.title.innerHTML = post.title;
        this.virtualModal.meta.duration.innerHTML = post.meta.duration;
        this.virtualModal.meta.date.innerHTML = post.meta.date;
        this.virtualModal.meta.location.innerHTML = post.meta.location;
        this.virtualModal.content.innerHTML = post.content;
		this.virtualModal.img.style.backgroundImage = 'url(' + post.featured_image + ')';
		if (post.booking_link){
			this.virtualModal.book.classList.remove('d-none');
			this.virtualModal.book.setAttribute('href', post.booking_link)
		}
		else{
			this.virtualModal.book.classList.add('d-none');
		}
        post.related.prev.id ? this.setNavLink(this.virtualModal.prev, post.related.prev) : this.setNavLink(this.virtualModal.prev, null);
        post.related.next.id ? this.setNavLink(this.virtualModal.next, post.related.next) : this.setNavLink(this.virtualModal.next, null);
        post.related.prev.id ? this.setNavLink(this.virtualModal.prev, post.related.prev) : this.setNavLink(this.virtualModal.prev, null);
        post.related.next.id ? this.setNavLink(this.virtualModal.next, post.related.next) : this.setNavLink(this.virtualModal.next, null);
        this.virtualModal.sharing.facebook.setAttribute('href', encodeURI('http://www.facebook.com/sharer.php?u=' + post.link));
        this.virtualModal.sharing.twitter.setAttribute('href', encodeURI('https://twitter.com/share?url=' + post.link + "&text=" + post.title));
        this.virtualModal.sharing.email.setAttribute('href', encodeURI('mailto:?Body=' + post.title + ' ' + post.link));
        history.pushState(post, post.title, post.link);
        document.title = post.title;
    }

    setNavLink(elements, data = null) {
        elements.forEach(element => {
            if (!data) {
                element.classList.add('disabled');
                element.dataset.id = ''
                element.setAttribute('href', '')
            } else {
                element.dataset.id = data.id;
                element.setAttribute('href', data.link)
                element.classList.remove('disabled');
            }
        });
    }

    loadModal(slug = null) {
        let url;
        if (slug || this.postId) {
            if (slug) {
                // console.log('Slug:', slug)
                url = '/wp-json/sw/get-excursion-by-slug/' + slug;
            } else {
                // console.log('Post Id:', this.postId)
                url = '/wp-json/sw/get-excursion/' + this.postId;
            }
            fetch(url).then(res => {
                res.json().then(post => {
                    if (!this.isOpen) {
                        if (this.bodyClasses) {
                            document.body.classList.add(...this.bodyClasses);
                        }
                        this.modal.style.overflow = '';
                        this.modal.classList.add('open');
                        this.isOpen = true;
                    }
                    this.setPostData(post);
                });
            })
        }
    }

    closeModal() {
        if (this.isOpen) {
            if (this.bodyClasses) {
                document.body.classList.remove(this.bodyClasses);
            }
            this.modal.style.overflow = 'hidden';
            this.modal.classList.remove('open');
            this.isOpen = false;
            history.pushState(null, "Excursions - Zeus is Loose", this.baseUrl)
            document.title = "Excursions - Zeus is Loose";
        }
    }

}